import { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Container,
  Link,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import flowSyncLogo from '../../assets/flow_sync_app_logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const navLinks = [
    { label: 'Features', id: 'features' },
    { label: 'Workflow', id: 'workflow' },
    { label: 'Benefits', id: 'benefits' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contact Us', id: 'contact' },
  ];

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  useEffect(() => {
    const handleScrollSpy = () => {
      const sections = navLinks.map((link) =>
        document.getElementById(link.id)
      );

      let current = 'home';

      sections.forEach((section) => {
        if (!section) return;
        const rect = section.getBoundingClientRect();
        if (rect.top <= 120 && rect.bottom >= 120) {
          current = section.id;
        }
      });

      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScrollSpy);
    return () => window.removeEventListener('scroll', handleScrollSpy);
  }, []);

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: 'white',
          color: 'black',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            sx={{
              height: 80,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box
                component="img"
                src={flowSyncLogo}
                alt="FlowSync Logo"
                sx={{ width: 40, height: 40 }}
              />

              <Typography variant="h6" fontWeight={700}>
                FlowSync
              </Typography>
            </Box>

            {!isMobile && (
              <Box sx={{ display: 'flex', gap: 4 }}>
                {navLinks.map((link) => {
                  const isActive = activeSection === link.id;

                  return (
                    <Link
                      key={link.id}
                      underline="none"
                      onClick={() => handleScroll(link.id)}
                      sx={{
                        cursor: 'pointer',
                        fontWeight: 600,
                        position: 'relative',
                        color: isActive ? 'primary.main' : 'text.secondary',

                        '&::after': isActive
                          ? {
                              content: '""',
                              position: 'absolute',
                              left: 0,
                              bottom: -4,
                              width: '100%',
                              height: '2px',
                              backgroundColor: 'primary.main',
                              borderRadius: 2,
                            }
                          : {},
                      }}
                    >
                      {link.label}
                    </Link>
                  );
                })}
              </Box>
            )}

            {isMobile && (
              <IconButton onClick={() => setIsMenuOpen(true)}>
                <MenuIcon />
              </IconButton>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      {/* DRAWER */}
      <Drawer
        anchor="right"
        open={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
      >
        <Box sx={{ width: 280, p: 3 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mb: 3,
            }}
          >
            <Typography variant="h6" fontWeight={700}>
              FlowSync
            </Typography>

            <IconButton onClick={() => setIsMenuOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          <List>
            {navLinks.map((link) => {
              const isActive = activeSection === link.id;

              return (
                <ListItem key={link.id} disablePadding>
                  <ListItemButton
                    onClick={() => {
                      handleScroll(link.id);
                      setIsMenuOpen(false);
                    }}
                    sx={{
                      borderLeft: isActive
                        ? '4px solid #1976d2'
                        : '4px solid transparent',
                      bgcolor: isActive ? 'rgba(25,118,210,0.08)' : 'transparent',
                    }}
                  >
                    <ListItemText
                      primary={link.label}
                      primaryTypographyProps={{
                        fontWeight: isActive ? 700 : 500,
                        color: isActive ? 'primary.main' : 'text.primary',
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;